import React, { useCallback, useMemo, useState } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { memberRequest, sendMessageToParent } from "../../../../utils";
import { redeemDiscountCardApi } from "../../../../urls";
import { Button } from "antd";
// import { USERS } from "../../../../constants";

interface RedeemPointsItemProps {
  data: GiftCardInfo;
  userPoints: number;
  index: number;
  onRedeem: (data: GiftCardInfo) => void;
  customerId: number;
}

interface GiftCardInfo {
  id: number;
  type: number;
  value: number;
  amount: string;
  points: number;
  amountText: string;
}

const RedeemPointsItem: React.FC<RedeemPointsItemProps> = ({
  data,
  userPoints,
  onRedeem,
  customerId,
  index,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const isDisabled = useMemo(() => {
    return userPoints < data.points || !userPoints;
  }, [userPoints, data.points]);

  const handleRedeem = useCallback(async () => {
    if (userPoints >= data.points) {
      // 这里要延迟执行一下，不然自埋点会统计不到，因为出现loading后，会找不到父级元素
      setTimeout(() => {
        setLoading(true);
      }, 100);

      const res = await memberRequest({
        url: redeemDiscountCardApi,
        method: "POST",
        data: {
          customer_id: customerId,
          redeem_type: data.id,
          num: 1,
        },
      });

      setLoading(false);

      if (res.data.code === 200) {
        onRedeem?.(data);
      } else {
        sendMessageToParent({
          type: "member-toast",
          data: {
            type: "error",
            message: "Redeem failed",
            duration: 3000,
          },
        });
      }
    } else {
      sendMessageToParent({
        type: "member-toast",
        data: {
          type: "error",
          message: "Points not enough",
          duration: 3000,
        },
      });
    }
  }, [data, userPoints, customerId, onRedeem]);

  return (
    <div key={data.id} className={styles.giftCardItem}>
      <div className={styles.giftCardLabel}>
        <span>Member Reward</span>
      </div>
      <div className={styles.giftCardContent}>
        <div className={styles.leftSection}>
          <div className={styles.amount}>{data.amountText}</div>
          <div className={styles.points}>{data.points} points</div>
        </div>
        <div className={styles.rightSection}>
          <Button
            loading={loading}
            data-element-id={`click-redeem-points-btn-${
              isDisabled ? "disabled" : "enabled"
            }`}
            className={classNames(styles.redeemButton, {
              [styles.disable]: isDisabled,
            })}
            onClick={handleRedeem}
          >
            {loading ? "" : "Redeem"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RedeemPointsItem;
